import { PropTypes } from 'prop-types';

export const defaultProps = {
  mapStyle: 'academiaedu/cj29il9o400142sqmyhdh2yif',
  zoom: 5,
  bearing: 0,
  pitch: 0,
  width: 345,
  height: 100,
};

export const propTypes = {
  mapStyle: PropTypes.string.isRequired,
  zoom: PropTypes.number.isRequired,
  bearing: PropTypes.number.isRequired,
  pitch: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
};
